import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Button,
  Card,
  ListGroup,
  Form,
  Container,
  Spinner,
  Image,
} from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { BsHeart, BsHeartFill } from "react-icons/bs";
import PaginatedList from "./PaginatedList";
import CommonModal from "components/CommonModal";
import { stripHtmlTags } from "utils/helpers";
import { fetchCategoryProducts } from "api/ProductService";
import {
  toggleFavorite,
  getMyProductSupportWithoutLimit,
} from "api/ActivityService";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuth } from "../context/UserContext";
import { toast } from "react-toastify";
import { Sentry } from "react-activity";
import RatingStars from "./RatingStars";
import { FaStar, FaStarHalfAlt } from "react-icons/fa";
import IMAGES from "constants/images";
import ReactShowMoreText from "react-show-more-text";
import Loader from "./Loader";
const addToListSchema = yup.object().shape({
  listOption: yup.string().required("Please select an option"),
  existingList: yup.string().when("listOption", {
    is: "existing",
    then: () => yup.string().required("Please select a list"),
    otherwise: () => yup.string().nullable(),
  }),
  newListName: yup.string().when("listOption", {
    is: "new",
    then: () =>
      yup
        .string()
        .trim()
        .required("List name is required")
        .min(1, "List name cannot be empty"),
    otherwise: () => yup.string().nullable(),
  }),
});
const AllProductComponent = ({ userId }) => {
  const navigate = useNavigate();
  const location=useLocation()
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const { isLoggedIn, user } = useAuth();
  const [is_disabled, setIsDisabled] = useState(false);
  const [productId, setProductId] = useState("");
  const [show, setShow] = useState("");
  const [supportLists, setSupportLists] = useState([]);
  const {
    handleSubmit,
    register,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(addToListSchema),
    defaultValues: {
      listOption: "existing",
      existingList: supportLists[0]?._id || "",
      newListName: "",
    },
  });
  const listOption = watch("listOption");
  const handleSelect = (product) => {
    if (selectedProducts.includes(product)) {
      setSelectedProducts(selectedProducts.filter((p) => p !== product));
    } else if (selectedProducts.length < 3) {
      // Changed from 2 to 3 for max selection
      setSelectedProducts([...selectedProducts, product]);
    } else {
      toast.warning("You can select maximum 3 products for comparison.");
    }
  };
  const openFavModal = async (id) => {
    if (!isLoggedIn) {
      toast.error("Please login first to add favorites.");
      return;
    }
    setProductId(id);
    if (supportLists.length == 0) {
      try {
        setLoading(true);
        const res = await getMyProductSupportWithoutLimit();
        if (res.success) {
          const supportData = res.body.data;
          setSupportLists(supportData);
          setLoading(false);
        }
      } catch (error) {
        console.error("Failed to fetch product details", error);
      }
    }
    setShow(true);
  };
  const handleRemove = (product) => {
    setSelectedProducts(selectedProducts.filter((p) => p !== product));
  };

  const handleClearAll = () => {
    setSelectedProducts([]);
  };
  const handleAddToList = async (data) => {
    try {
      if (!isLoggedIn) {
        toast.error("Please login first to add favorites.");
        return;
      }

      setIsDisabled(true);

      let listId;
      if (data.listOption === "existing") {
        listId = data.existingList;
        const payload = {
          productId: productId,
          listId: listId,
        };
        const res = await toggleFavorite(payload);
        if (res.success) {
          toast.success("Product added to list successfully");
          setShow("");
          setIsDisabled(false);
          reset();
        }
      } else {
        const payload = {
          productId: productId,
          name: data.newListName,
        };
        const res = await toggleFavorite(payload);
        if (res.success) {
          setSupportLists(res.body.data);
          toast.success("Product added to list successfully");
          setShow("");
          setIsDisabled(false);
          reset();
        }
      }
    } catch (err) {
      console.error("Error adding to list:", err);
      toast.error(err.message || "Failed to add to list");
      setIsDisabled(false);
    }
  };
  const [products, setProducts] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);
  const limit = 10;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (userId) {
      fetchProducts();
    }
  }, [userId, page]);

  // const getSortParams = () => {
  //   for (const key in sortOptions) {
  //     const value = sortOptions[key];
  //     if (value) {
  //       return {
  //         sortBy: key,
  //         sortOrder: value === "low-to-high" ? "asc" : "desc",
  //       };
  //     }
  //   }
  //   return { sortBy: "", sortOrder: "" };
  // };
  // const { sortBy, sortOrder } = getSortParams();

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const res = await fetchCategoryProducts({
        userId,
        page,
        limit,
      });

      if (res.success) {
        setProducts(res.body.data);
        setTotalItems(res.body.total);
        // setTotalCount(res.body.total);
      } else {
        navigate("/not-found");
      }
    } catch (err) {
      console.error("Failed to fetch category products", err);
    } finally {
      setLoading(false);
    }
  };

  // Navigate to comparison page with selected products
  const handleCompare = () => {
    // Save selected products to localStorage
    localStorage.setItem(
      "comparisonProducts",
      JSON.stringify(selectedProducts)
    );

    // Navigate to comparison page with selected products
    navigate("/product-comparision", {
      state: { products: selectedProducts },
    });
  };

  return (
    <div>
      {loading ? (
        <div className="loaderdiv">
          <Sentry color="#e91515" size={40} speed={1} animating={true} />
          {/* <Loader  /> */}
        </div>
      ) : totalItems > 0 ? (
        <Container>
          <Row className="categories_section categories_section1">
            {products.map((product, index) => {
             const htmlDescription=stripHtmlTags(product?.description)
              return (
              <Col
                lg={12}
                xl={12}
                md={12}
                sm={12}
                key={index}
                // className="mb-2 mt-4"
                className=" d-flex "
                style={{ marginBottom: "50px" }}
              >
                <Card className="w-100 h-100" style={{border:userId && "1px solid #b9b9b9"}}>
                  <Card.Body className="d-flex flex-column">
               {!userId &&     <Form.Check
                      type="checkbox"
                      id={`compare-${index}`}
                      name="compare"
                      label="Compare Product"
                      className="comparepos"
                      checked={selectedProducts.includes(product)}
                      onChange={() => handleSelect(product)}
                    />}
                       {(!user || user.role === "user") && (
                        <div className="d-flex justify-content-end">
                        <Button
                          onClick={() => {
                            if (!isLoggedIn) {
                              toast.error("Please login to write a review", {
                                toastId: "login-required"
                              });
                              return;
                            }
                            navigate("/write-a-review");
                            const updatedChecked = [product];

                            localStorage.setItem(
                              "checkedProducts",
                              JSON.stringify(updatedChecked)
                            );
                            localStorage.setItem("step", 2);
                          }}
                          variant="danger"
                          size="sm"
                        >
                          Write A Review
                        </Button></div>
                      )}

                      
                    <Link
                      to={`/product-details/${product.slug}`}
                      className="iconBox"
                      style={{
                        backgroundColor: product.brandColors,
                        marginTop:(!user || user.role === "user" )&& "-100px"
                      }}
                      state={
                        {
                          // resource: product,
                          // catData: catData,
                          // pathName: pathName,
                        }
                      }
                    >
                      <img
                        src={product.logoUrl}
                        alt={product.name}
                        style={{ width: 48, height: 48, objectFit: "contain" }}
                      />
                    </Link>
                    <div className="d-flex justify-content-between align-items-center mb-4 flex_col gap-2">
                      <div>
                        <Link
                          to={`/product-details/${product.slug}`}
                          className="text-decoration-none text-dark hoverAnchorColor"
                          state={
                            {
                              // resource: product,
                              // catData: catData,
                              // pathName: pathName,
                            }
                          }
                        >
                          <Card.Title className="mb-2">
                            {product.name}
                          </Card.Title>
                        </Link>
                        <Card.Text className="mb-0 mb-0 d-flex align-items-center gap-1 softwre_flex  ">
                          <RatingStars rating={product.avgRating} />
                          <div className="total_review_text">
                            ({product.totalReviews}) {product.avgRating}{" "}
                            <span>out of</span> 5
                          </div>
                        </Card.Text>
                      </div>
                      {!userId && (!user || user.role === "user"   ) && (
                        <Button
                          onClick={() => {
                            if (!isLoggedIn) {
                              toast.error("Please login to write a review", {
                                toastId: "login-required"
                              });
                              return;
                            }
                            navigate("/write-a-review");
                            const updatedChecked = [product];

                            localStorage.setItem(
                              "checkedProducts",
                              JSON.stringify(updatedChecked)
                            );
                            localStorage.setItem("step", 2);
                          }}
                          variant="danger"
                          size="sm"
                        >
                          Write A Review
                        </Button>
                      )}
                    </div>
                    <Card.Title className="mb-2">
                      Product Description
                    </Card.Title>
                    <Card.Text className="para truncate-2-lines" >
                      {/* <ReactShowMoreText
                        lines={4}
                        more="See more"
                        less="See less"
                        anchorClass="see-more-link"
                        expanded={false}
                        width={0}
                        style={{
                          whiteSpace: "pre-wrap",
                          lineHeight: "1.6",
                          marginBottom: "1rem",
                          wordBreak: "break-word",
                        }}
                      > */}
                       {htmlDescription}
                      {/* </ReactShowMoreText> */}
                      {/* {stripHtmlTags(product.description)?.slice(0, 100)}... */}
                    </Card.Text>
                    <Card.Title className="mb-2 font14 fw-bold">
                      Other Info
                    </Card.Title>
                    <ListGroup className="customListGroup">
                     {product.whoCanUse?.length > 0 && <ListGroup.Item>
                        <Icon icon="tabler:users" fontSize={24} />
                        <span>
                          <strong>Users</strong> (
                          {product.whoCanUse
                            ?.map((item) => item.title)
                            .join(", ")}
                          )
                        </span>
                      </ListGroup.Item>}
                     {product.industries?.length > 0 && <ListGroup.Item>
                        <Icon icon="clarity:building-line" fontSize={24} />
                        <span>
                          <strong>Industries</strong> (
                          {product.industries
                            ?.map((item) => item.title)
                            .join(", ")}
                          )
                        </span>
                      </ListGroup.Item>}
                     {product.marketSegment?.length > 0 && <ListGroup.Item>
                        <Icon icon="ph:line-segments" fontSize={24} />
                        <span>
                          <strong>Market Segment</strong> (
                          {product.marketSegment
                            ?.map((item) => item.title)
                            .join(", ")}
                          )
                        </span>
                      </ListGroup.Item>}
                    </ListGroup>

                    <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap">
                      <Button
                        variant="link"
                        className="d-flex align-items-center text-secondary fw-normal font14 text-decoration-none p-0"
                        //onClick={() => handleToggleFavorite(product._id)}
                        onClick={() => openFavModal(product._id)}
                      >
                        <BsHeart className="text-muted me-2" size={20} />
                        Save to My List
                      </Button>
                      {product?.pricing?.length > 0 && (
                        <Button
                          variant="outline-danger"
                          className="ms-0 ms-md-auto px-3 border-radius-100"
                        >
                          Entry Level Price:
                          <span className="text-primary">
                            {" "}
                            {Math.min(
                              ...product.pricing.map(
                                (p) => parseFloat(p?.price) || 0
                              )
                            ) === 0
                              ? "$ Free"
                              : `$${Math.min(
                                  ...product.pricing.map(
                                    (p) => parseFloat(p?.price) || 0
                                  )
                                ).toFixed(2)}`}
                          </span>
                        </Button>
                      )}

                      <Button variant="info" className="border-radius-100 px-4">
                        Try For Free
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            )})}
            <PaginatedList
              totalItems={totalItems}
              itemsPerPage={limit}
              currentPage={page}
              onPageChange={(pageNum) => setPage(pageNum)}
            />
          </Row>
        </Container>
      ) : (
        <Container className="text-center py-5 min_height">
          <Col xs={12}>
            <div className="text-center py-5">
              <Image
                src={IMAGES.emptyState}
                alt=""
                height="30%"
                width="30%"
                className="mb-4"
                // className="imgUser"
              />
              <h5>No data available</h5>
            </div>
          </Col>
        </Container>
      )}

      {/* Sticky Comparison Bar - Updated to handle up to 3 products */}
      {selectedProducts.length > 0 && (
        <div className="sticky-bottom compareBar">
          <Button
            className="hide_btn"
            variant="outline-info"
            onClick={handleClearAll}
          >
            Remove All
          </Button>
          <div className="d-flex gap-3">
            {selectedProducts.map((product, index) => (
              <div
                key={index}
                className="position-relative proBox"
                style={{
                  backgroundColor: product.bgColor,
                }}
              >
                <div className="closeBtn">
                  <button
                    className="btn-close"
                    onClick={() => handleRemove(product)}
                  >
                    <Icon icon="basil:cross-solid" fontSize={20} />
                  </button>
                </div>
                <img
                  src={product.logoUrl}
                  alt={product.name}
                  style={{ width: 40, height: 40 }}
                />
              </div>
            ))}
          </div>
          {/* Changed condition to allow comparison with 2 or 3 products */}
          {selectedProducts.length >= 2 && (
            <div className="d-flex gap-2">
              <Button
                className="show_btn"
                variant="outline-info"
                onClick={handleClearAll}
              >
                Remove All
              </Button>
              <Button variant="info" onClick={handleCompare}>
                Compare Now {selectedProducts.length === 3 ? "(3)" : "(2)"}
              </Button>
            </div>
          )}
          {selectedProducts.length === 1 && (
            <div className="text-info">
              Select at least one more product to compare
            </div>
          )}
        </div>
      )}
      <CommonModal
        paraStyle={{ maxWidth: "600px", marginTop: "10px" }}
        title=""
        para=""
        body={
          <div style={{ marginTop: "-40px" }}>
            <h3 className="text-start mb-4">Add to My List</h3>
            <Form onSubmit={handleSubmit(handleAddToList)}>
              <Form.Group className="mb-3">
                <Form.Check
                  type="radio"
                  id="existing-list-option"
                  label="Choose from existing lists"
                  value="existing"
                  {...register("listOption")}
                />

                {listOption === "existing" && (
                  <Form.Select
                    className="mt-2"
                    {...register("existingList")}
                    disabled={is_disabled}
                  >
                    <option value="">Select List</option>
                    {supportLists.map((i) => (
                      <option key={i._id} value={i._id}>
                        {i.name}
                      </option>
                    ))}
                  </Form.Select>
                )}
                {errors.existingList && (
                  <span className="text-danger mt-1 text-start d-block small">
                    {errors.existingList.message}
                  </span>
                )}
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Check
                  type="radio"
                  id="new-list-option"
                  label="Create new list"
                  value="new"
                  {...register("listOption")}
                />

                {listOption === "new" && (
                  <Form.Control
                    type="text"
                    placeholder="Enter new list name"
                    className="mt-2"
                    {...register("newListName")}
                    disabled={is_disabled}
                  />
                )}
                {errors.newListName && (
                  <span className="text-danger mt-1 text-start d-block small">
                    {errors.newListName.message}
                  </span>
                )}
              </Form.Group>

              <Button
                type="submit"
                variant="info"
                className="w-100 border-radius-100 mt-3"
                disabled={is_disabled}
              >
                {is_disabled ? <Spinner animation="border" size="sm" /> : "Add"}
              </Button>
            </Form>
          </div>
        }
        show={show !== ""}
        onClose={() => {
          setShow("");
          reset();
        }}
      />
    </div>
  );
};

export default AllProductComponent;
